import { TextInput } from 'react-admin';
import ArrayForm from './ArrayForm';
import BoundedInput from './BoundedInput';

const ArrayHospitalVisitService = ({ index, source, }: { source: string, index: number }) => {
    return (
        <ArrayForm source={source} grid={0} simpleFormIteratorProps={{
            sx: {
                '& .RaSimpleFormIterator-form': {
                    display: 'grid',
                    gap: '0px',
                    columnGap: '10px',
                    gridTemplateAreas: ` 'title_en title_tc title_sc' 'list list list' 'tel_title_en tel_title_tc tel_title_sc' 'tel_en tel_tc tel_sc'`
                }
            }
        }}>
            <BoundedInput source={`title_en`} input={<TextInput source="title_en" />} />
            <BoundedInput source={`title_tc`} input={<TextInput source="title_tc" />} />
            <BoundedInput source={`title_sc`} input={<TextInput source="title_sc" />} />
            <ArrayForm source={'list'} grid={0} sx={{ gridArea: 'list', }} simpleFormIteratorProps={{
                sx: {
                    '& .RaSimpleFormIterator-form': {
                        display: 'grid',
                        gap: '0px',
                        columnGap: '10px',
                        gridTemplateAreas: `'name_en name_tc name_sc'`
                    }
                }
            }}>
                <BoundedInput source={`name_en`} label="Name EN" input={<TextInput source="dummy" />} />
                <BoundedInput source={`name_tc`} label="Name TC" input={<TextInput source="dummy" />} />
                <BoundedInput source={`name_sc`} label="Name SC" input={<TextInput source="dummy" />} />
            </ArrayForm>
            <BoundedInput source={`tel_title_en`} input={<TextInput source="tel_title_en" />} />
            <BoundedInput source={`tel_title_tc`} input={<TextInput source="tel_title_tc" />} />
            <BoundedInput source={`tel_title_sc`} input={<TextInput source="tel_title_sc" />} />
            <BoundedInput source={`tel_en`} input={<TextInput source="tel_en" />} />
            <BoundedInput source={`tel_tc`} input={<TextInput source="tel_tc" />} />
            <BoundedInput source={`tel_sc`} input={<TextInput source="tel_sc" />} />
        </ArrayForm>
    )
}

export default ArrayHospitalVisitService;